function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 237.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "metamask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "242.8 0.5 143.3 74.4 161.7 30.8 242.8 0.5",
    style: {
      fill: "#e2761b",
      stroke: "#e2761b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.1 0.5 111.8 75.1 94.3 30.8 13.1 0.5",
    style: {
      fill: "#e4761b",
      stroke: "#e4761b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207 171.8 180.5 212.4 237.2 228 253.5 172.7 207 171.8",
    style: {
      fill: "#e4761b",
      stroke: "#e4761b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2.6 172.7 18.8 228 75.5 212.4 49 171.8 2.6 172.7",
    style: {
      fill: "#e4761b",
      stroke: "#e4761b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.3 103.2 56.5 127.1 112.8 129.6 110.8 69.1 72.3 103.2",
    style: {
      fill: "#e4761b",
      stroke: "#e4761b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.6 103.2 144.6 68.4 143.3 129.6 199.5 127.1 183.6 103.2",
    style: {
      fill: "#e4761b",
      stroke: "#e4761b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.5 212.4 109.3 195.9 80.1 173.1 75.5 212.4",
    style: {
      fill: "#e4761b",
      stroke: "#e4761b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.6 195.9 180.5 212.4 175.8 173.1 146.6 195.9",
    style: {
      fill: "#e4761b",
      stroke: "#e4761b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.5 212.4 146.6 195.9 149.3 218 149 227.3 180.5 212.4",
    style: {
      fill: "#d7c1b3",
      stroke: "#d7c1b3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.5 212.4 107 227.3 106.8 218 109.3 195.9 75.5 212.4",
    style: {
      fill: "#d7c1b3",
      stroke: "#d7c1b3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.5 158.5 79.3 150.2 99.2 141.1 107.5 158.5",
    style: {
      fill: "#233447",
      stroke: "#233447",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.4 158.5 156.7 141.1 176.7 150.2 148.4 158.5",
    style: {
      fill: "#233447",
      stroke: "#233447",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.5 212.4 80.3 171.8 49 172.7 75.5 212.4",
    style: {
      fill: "#cd6116",
      stroke: "#cd6116",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.7 171.8 180.5 212.4 207 172.7 175.7 171.8",
    style: {
      fill: "#cd6116",
      stroke: "#cd6116",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.5 127.1 143.3 129.6 148.5 158.5 156.8 141.1 176.8 150.2 199.5 127.1",
    style: {
      fill: "#cd6116",
      stroke: "#cd6116",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.3 150.2 99.3 141.1 107.5 158.5 112.8 129.6 56.5 127.1 79.3 150.2",
    style: {
      fill: "#cd6116",
      stroke: "#cd6116",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.5 127.1 80.1 173.1 79.3 150.2 56.5 127.1",
    style: {
      fill: "#e4751f",
      stroke: "#e4751f",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.8 150.2 175.8 173.1 199.5 127.1 176.8 150.2",
    style: {
      fill: "#e4751f",
      stroke: "#e4751f",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.8 129.6 107.5 158.5 114.1 192.6 115.6 147.7 112.8 129.6",
    style: {
      fill: "#e4751f",
      stroke: "#e4751f",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.3 129.6 140.6 147.6 141.8 192.6 148.5 158.5 143.3 129.6",
    style: {
      fill: "#e4751f",
      stroke: "#e4751f",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.5 158.5 141.8 192.6 146.6 195.9 175.8 173.1 176.8 150.2 148.5 158.5",
    style: {
      fill: "#f6851b",
      stroke: "#f6851b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.3 150.2 80.1 173.1 109.3 195.9 114.1 192.6 107.5 158.5 79.3 150.2",
    style: {
      fill: "#f6851b",
      stroke: "#f6851b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149 227.3 149.3 218 146.8 215.8 109.1 215.8 106.8 218 107 227.3 75.5 212.4 86.5 221.4 108.8 236.9 147.1 236.9 169.5 221.4 180.5 212.4 149 227.3",
    style: {
      fill: "#c0ad9e",
      stroke: "#c0ad9e",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.6 195.9 141.8 192.6 114.1 192.6 109.3 195.9 106.8 218 109.1 215.8 146.8 215.8 149.3 218 146.6 195.9",
    style: {
      fill: "#161616",
      stroke: "#161616",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247 79.2 255.5 38.4 242.8 0.5 146.6 71.9 183.6 103.2 235.9 118.5 247.5 105 242.5 101.4 250.5 94.1 244.3 89.3 252.3 83.2 247 79.2",
    style: {
      fill: "#763d16",
      stroke: "#763d16",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.5 38.4 9 79.2 3.6 83.2 11.6 89.3 5.5 94.1 13.5 101.4 8.5 105 20 118.5 72.3 103.2 109.3 71.9 13.1 0.5 0.5 38.4",
    style: {
      fill: "#763d16",
      stroke: "#763d16",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.9 118.5 183.6 103.2 199.5 127.1 175.8 173.1 207 172.7 253.5 172.7 235.9 118.5",
    style: {
      fill: "#f6851b",
      stroke: "#f6851b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.3 103.2 20 118.5 2.6 172.7 49 172.7 80.1 173.1 56.5 127.1 72.3 103.2",
    style: {
      fill: "#f6851b",
      stroke: "#f6851b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.3 129.6 146.6 71.9 161.8 30.8 94.3 30.8 109.3 71.9 112.8 129.6 114 147.8 114.1 192.6 141.8 192.6 142 147.8 143.3 129.6",
    style: {
      fill: "#f6851b",
      stroke: "#f6851b",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.02282739.svg";
export { ForwardRef as ReactComponent };